export default {
  strict: true,
  namespaced: true,
  state: {
    tncReservations: {
      list: [],
      checked: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'cb.pickupTime',
      orderAsc: 1,
      type: 'all',
      isLoading: false,
      search: '',
      viewingInMap: false
    },
    readyToGo: {
      show: false,
      id: 0,
      loading: false,
      success: false,
      table: ''
    },
    notes: {
      show: false,
      message: '',
      loading: false,
      success: false
    },
  },
  mutations: {
    resetTncReservationsList (state) { state.tncReservations.list = [] },
    addTncReservation (state, value) { state.tncReservations.list.push(value) },
    setTncReservationsChecked (state, value) { state.tncReservations.checked = value },
    removeTncReservationsChecked (state) {
      if (state.tncReservations.checked.length && state.tncReservations.checked.length === 1) {
        let index = state.tncReservations.list.findIndex(x => x.id === state.tncReservations.checked[0])
        state.tncReservations.list.splice(index, 1)
        state.tncReservations.checked = []
      }
    },
    setTncReservationsMaxList (state, value) { state.tncReservations.maxList = value },
    setTncReservationsCurrentPage (state, value) { state.tncReservations.currentPage = value },
    setTncReservationsPerPage (state, value) { state.tncReservations.perPage = value },
    setTncReservationsOrder (state, value) { state.tncReservations.order = value },
    setTncReservationsOrderAsc (state, value) { state.tncReservations.orderAsc = value },
    setTncReservationsIsLoading (state, value) { state.tncReservations.isLoading = value },
    setTncReservationsSearch (state, value) { state.tncReservations.search = value },
    setViewingInMap (state, value) { state.tncReservations.viewingInMap = value },
    setReadyToGoShow (state, value) { state.readyToGo.show = value },
    setReadyToGoID (state, value) { state.readyToGo.id = value },
    setReadyToGoLoading (state, value) { state.readyToGo.loading = value },
    setReadyToGoSuccess (state, value) { state.readyToGo.success = value },
    setReadyToGoTable (state, value) { state.readyToGo.table = value },
    setNotesShow (state, value) {state.notes.show = value },
    setNotesMessage (state, value) {state.notes.message = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/laxit/tnc-reservations.js